var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { styles } from './input.styles';
import { InputContainer } from './input-container';
import { getSizeClasses, getAlignClasses, getVariantClasses } from './input.helpers';
import { ClickAwayListener } from '@mui/material';
export var InputRoot = function (_a) {
    var _b;
    var _c = _a.onRootClick, onRootClick = _c === void 0 ? function () { return null; } : _c, children = _a.children, className = _a.className, onClickAway = _a.onClickAway, props = __rest(_a, ["onRootClick", "children", "className", "onClickAway"]);
    var root_clasess = classNames(styles.base, __assign(__assign(__assign((_b = {}, _b[styles.disabled] = props.disabled, _b[styles.errored] = props.errored, _b), getVariantClasses(props)), getSizeClasses(props)), getAlignClasses(props)), className);
    var content = (_jsx("div", __assign({ className: root_clasess, onClick: onRootClick }, { children: _jsx(InputContainer, __assign({}, props, { children: children })) })));
    if (onClickAway)
        return _jsx(ClickAwayListener, { onClickAway: onClickAway, children: content });
    else
        return content;
};
